import { validate } from 'email-validator';

import { Validator } from '../../types/Validator';

const errorCode = 'IS_NOT_EMAIL';

const email: Validator = value => {
  if (value === undefined) return;
  return validate(String(value)) ? undefined : { errorCode };
};

export { email, errorCode };
